import { useMemo } from "react"
import { mapAuthUser, mapAuthUserType } from "../../shared/mapAuthUsers"
import { AuthService, AuthUserType } from "../../shared/types"
import { useParentContext } from "./useParentContext"
import { config } from "../../shared/config"

export const useParentAuthService = (): AuthService => {
  const { login, getToken, logout, isLoading, isAuthenticated, user } = useParentContext()

  const authUserType = useMemo<AuthUserType>(() => mapAuthUserType(user), [user])

  const isEmbedded = useMemo(() => config().embedded, [])

  return useMemo<AuthService>(
    () => ({
      resetPassword: async () => {},
      login: async () => {
        await login()
        return true
      },
      getToken: () => getToken(),
      logout: async () => {
        await logout()
      },
      isAuthenticated: isAuthenticated && user !== undefined && !isLoading,
      isLoading,
      isEmbedded,
      getAuthId: () => user?.id ?? null,
      getAuthType: () => authUserType ?? null,
      getAuthUser: () => mapAuthUser(user),
    }),
    [login, getToken, logout, user, authUserType, isAuthenticated, isLoading]
  )
}
